import type { AbstractSearchFormProps } from "@component/assets/AbstractListingCalculator/AbstractSearchForm";
import autobind from "autobind-decorator";
import { getUrlParameter } from "bm-ui-kit";
import { CorporateBankAccountSmallCalculator } from "../SmallCalculator/CorporateBankAccountSmallCalculator";
import type {
	CorporateBankAccountSmallCalculatorFormFields,
	CorporateBankAccountSmallCalculatorProps,
} from "../SmallCalculator/CorporateBankAccountSmallCalculator";
import type { CorporateBankAccountSearchParams } from "./types";

interface Props
	extends CorporateBankAccountSmallCalculatorProps,
		AbstractSearchFormProps<CorporateBankAccountSearchParams> {
	className?: string;
	onSubmit: (searchParams: CorporateBankAccountSearchParams, isSort: boolean) => Promise<void>;
}

export class CorporateBankAccountSearchForm extends CorporateBankAccountSmallCalculator<Props> {
	public static defaultProps = {
		title: "Kérd szakértőnk segítségét!",
		outsideTitle: undefined,
		outsideTitleLink: undefined,
		bottomLogo: false,
	};

	public componentDidMount(): void {
		const { values } = this.state;
		super.componentDidMount();

		const renderCalculatorResult = getUrlParameter("renderCalculatorResult") !== undefined;

		if (renderCalculatorResult === true) {
			this.onSubmit(values, false);
		}
	}

	protected initValues(): CorporateBankAccountSmallCalculatorFormFields {
		const { initValues } = this.props;

		return {
			...super.initValues(),
			...initValues,
		};
	}

	@autobind
	protected async onSubmit(searchParams: CorporateBankAccountSearchParams, isSort: boolean): Promise<void> {
		const { onSubmit } = this.props;

		return this.promisePool.add(onSubmit(searchParams, isSort)).then(() => {
			this.onStep("result", true);
		});
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.CorporateBankAccountSearchForm`;
	}
}
